import _reduxForm from "redux-form/es/reduxForm";
import _Field from "redux-form/es/Field";
import React from 'react';
import classnames from 'classnames';
import UnderlinedInput from 'swag-client-common/components/inputs/underlined-input';
import ControlDialog from 'swag-client-common/components/info/control-dialog';
import { Button } from 'swag-client-common/components/ui/button';
import utilClasses from 'swag-client-common/styles/utilities.scss';
import { email, required } from 'swag-client-common/utils/redux-form-validators';
import classes from './forgot-password-popup.scss';
const ForgotPasswordPopup = ({
  errorMessage,
  handleSubmit,
  onSubmit,
  onShowSignUp,
  isSuccess,
  isError,
  isLoading,
  onClose,
  isOpen
}) => {
  const renderContent = () => {
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h2", {
      className: utilClasses.textCenter
    }, "Forgot password"), /*#__PURE__*/React.createElement("form", {
      className: classnames(utilClasses.textCenter, classes.form),
      onSubmit: handleSubmit(onSubmit)
    }, /*#__PURE__*/React.createElement(_Field, {
      name: "email",
      component: UnderlinedInput,
      type: "text",
      validate: [required, email],
      label: "Your email"
    }), /*#__PURE__*/React.createElement(Button, {
      type: "primary",
      size: "small",
      loading: isLoading,
      className: classes.submitButton
    }, "Reset password"), /*#__PURE__*/React.createElement("div", {
      className: classnames(utilClasses.smallGreyText, utilClasses.textCenter)
    }, "Don't have an account?", /*#__PURE__*/React.createElement("span", {
      className: classnames(utilClasses.smallBlueText, utilClasses.actionElement),
      onClick: onShowSignUp,
      "data-label": "GetStarted"
    }, ' ', "Get started")), isError && /*#__PURE__*/React.createElement("div", {
      className: utilClasses.error
    }, errorMessage), isSuccess && /*#__PURE__*/React.createElement("div", {
      className: utilClasses.success
    }, "Please follow the instructions from delivered e-mail")));
  };
  return /*#__PURE__*/React.createElement(ControlDialog, {
    open: isOpen,
    dialogClass: classes.popup,
    onRequestClose: onClose,
    content: renderContent(),
    dataPopup: "ForgotPassword"
  });
};
export default _reduxForm({
  form: 'forgotPassword'
})(ForgotPasswordPopup);